module.exports = __webpack_public_path__ + "e64718ab06838769c80edc4221a929b1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/mongolian-house.png
// module id = 2847
// module chunks = 0